import { CustomForm, CustomFormReportData, CustomFormSegmentReportData, isInputField } from "../amorg-common";
import { CustomFormAnswer } from '../amorg-common/DTOs/CustomFormAnswer';
import { customFormFieldFactory } from "../pages/customForms/_components/customFormFieldFactory";

export type CustomFormFilter = {
    fieldId:string, 
    label:string, 
    selectedValue:string, 
    values:{
        val:string, 
        label:string
    }[]
};

export const customFormHelper = {
    buildFilters,
    applyReportFilters,
    applyAnswerFilters
};

function buildFilters(form:CustomForm, report:CustomFormReportData)
{
    const filters:CustomFormFilter[] = [];
    for(const field of form.fields){
        if(isInputField(field)){
            const filter = customFormFieldFactory.getFilterValues(field, report);
            if(filter){
                filters.push(filter);
            }
        }
    }
    return filters;
}

function applyReportFilters(reports:CustomFormSegmentReportData[], filters:CustomFormFilter[])
{
    const filteredData:CustomFormSegmentReportData[] = [];
    for(const sr of reports){
        if(includeValue(sr.segmentSelections, filters)){
            filteredData.push(sr);
        }
    }
    return filteredData;
}

function applyAnswerFilters(answers:CustomFormAnswer[], filters:CustomFormFilter[])
{
    const filteredData:CustomFormAnswer[] = [];
    for(const row of answers){
        if(includeValue(row.selections, filters)){
            filteredData.push(row);
        }
    }
    return filteredData;
}

function includeValue(valueCollections:{fieldId:string, value:string}[], filters:CustomFormFilter[])
{
    for(const filter of filters){

        const valueCollectionField = valueCollections.find(ss => ss.fieldId === filter.fieldId);
        if(!valueCollectionField){
            // output to console but otherwise dont' interrupt user
            console.error('Field not found in value collection', filter.fieldId);
            return true;
        }

        if(filter.selectedValue !== '' && valueCollectionField?.value !== filter.selectedValue){
            return false;
        }
    }

    return true;
}